// extracted by mini-css-extract-plugin
module.exports = {"Device":"App_Device__1vnMx","Header":"App_Header__2rl_K","Footer":"App_Footer__3E1PI"};